import { Languages } from "lucide-react";
import { useState } from "react";

import { IconButton } from "@/components/ui/IconButton";
import { cn } from "@/lib/cn";
import { useDismiss } from "@/lib/useDismiss";
import { LOCALES, useI18n } from "@/lib/i18n";

export function LanguageSwitcher({ className }: { className?: string }) {
  const { locale, setLocale, t } = useI18n();
  const [open, setOpen] = useState(false);

  const { anchor: wrapper } = useDismiss<HTMLDivElement>(open, () => {
    setOpen(false);
  });

  return (
    <div className="relative" ref={wrapper}>
      <IconButton
        aria-expanded={open}
        className={className}
        aria-haspopup="menu"
        label={t("nav.language")}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <Languages className="h-4 w-4" />
      </IconButton>

      {open ? (
        <div
          className="absolute end-0 z-40 mt-1 w-40 overflow-hidden rounded-xl border border-line bg-surface py-1 shadow-overlay"
          role="menu"
        >
          {LOCALES.map((entry) => (
            <button
              aria-checked={entry.id === locale}
              className={cn(
                "flex w-full items-center justify-between px-3 py-2 text-start text-sm hover:bg-surface-raised",
                entry.id === locale ? "font-medium text-brand" : "text-ink",
              )}
              dir={entry.dir}
              key={entry.id}
              onClick={() => {
                setLocale(entry.id);
                setOpen(false);
              }}
              role="menuitemradio"
              type="button"
            >
              {entry.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
